/* ============================================================
   HYPE SIDE — Carrosséis de camisolas infinitos ([data-hs-rail])

   A fila é repetida três vezes (cópia · original · cópia) e começa no
   meio. Quando o cliente pára perto de uma ponta, salta sem se notar
   para a mesma camisola na cópia do meio — nunca chega ao fim e,
   depois da última, volta a aparecer a primeira. Não anda sozinho.
   ============================================================ */
(function () {
  function prepara(rail) {
    if (rail.__hsLoop) return;
    var itens = Array.prototype.slice.call(rail.children);
    if (itens.length < 2 || rail.scrollWidth <= rail.clientWidth + 4) return;
    rail.__hsLoop = true;

    function copia(el) {
      var c = el.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('data-hs-clone', '');
      c.removeAttribute('id');
      c.querySelectorAll('[id]').forEach(function (x) { x.removeAttribute('id'); });
      c.querySelectorAll('a, button, input, select, textarea').forEach(function (x) { x.setAttribute('tabindex', '-1'); });
      return c;
    }
    var antes = document.createDocumentFragment();
    var depois = document.createDocumentFragment();
    itens.forEach(function (el) { antes.appendChild(copia(el)); depois.appendChild(copia(el)); });
    rail.insertBefore(antes, rail.firstChild);
    rail.appendChild(depois);

    var n = itens.length;
    function largura() { return rail.children[n].offsetLeft - rail.children[0].offsetLeft; }

    function salta(px, absoluto) {
      var snap = rail.style.scrollSnapType, sb = rail.style.scrollBehavior;
      rail.style.scrollSnapType = 'none';
      rail.style.scrollBehavior = 'auto';
      rail.scrollLeft = absoluto ? px : rail.scrollLeft + px;
      // repõe o snap no frame seguinte, já na nova posição
      requestAnimationFrame(function () { rail.style.scrollSnapType = snap; rail.style.scrollBehavior = sb; });
    }

    // posição absoluta: o browser pode já ter compensado as cópias inseridas antes
    salta(largura(), true);

    var t = null, mexer = false;
    function confere() {
      if (mexer) return;
      var w = largura();
      if (rail.scrollLeft < w * 0.5) salta(w);
      else if (rail.scrollLeft > w * 1.5) salta(-w);
    }
    function depoisDeParar() { clearTimeout(t); t = setTimeout(confere, 140); }
    rail.addEventListener('touchstart', function () { mexer = true; }, { passive: true });
    rail.addEventListener('touchend', function () { mexer = false; depoisDeParar(); }, { passive: true });
    rail.addEventListener('scroll', depoisDeParar, { passive: true });
  }

  function iniciar() {
    document.querySelectorAll('[data-hs-rail]').forEach(prepara);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  // no editor do tema as secções são recarregadas
  document.addEventListener('shopify:section:load', iniciar);
})();
